import React from 'react';

export default function ChatMessage({ sender, children }) {
    const isBot = sender === 'bot';

    return (
        <div className={`oc-message-row ${isBot ? 'oc-message-row-bot' : 'oc-message-row-user'}`}>
            {isBot && (
                <div className="oc-avatar">
                    <img src="/cb_logo.png" alt="" className="oc-avatar-img" />
                </div>
            )}
            <div className={`oc-bubble ${isBot ? 'oc-bubble-bot' : 'oc-bubble-user'}`}>
                {children}
            </div>
        </div>
    );
}
